
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 40 40","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14.2 18.203V4.98c0-.8.21-1.558.581-2.229a3.106 3.106 0 00-1.55-.407c-1.603 0-2.903 1.18-2.903 2.636V17.72a7.932 7.932 0 013.871.485zM14.4 32.104L6.114 24.58c-.73-.663-1.133-1.546-1.133-2.485 0-.733.246-1.43.7-2.017a5.251 5.251 0 00-.848-.07c-1.264 0-2.452.447-3.346 1.258a1.12 1.12 0 00-.378.829c0 .31.136.609.378.828l10.554 9.583v6.323c0 .647.577 1.172 1.29 1.172h2.58v-4.582c0-1.252-.536-2.43-1.511-3.315z"}}),_c('path',{attrs:{"d":"M37.096 5.468c-1.603 0-2.903 1.18-2.903 2.637V4.98c0-1.456-1.3-2.636-2.903-2.636-1.604 0-2.903 1.18-2.903 2.636V2.636c0-1.456-1.3-2.636-2.904-2.636-1.603 0-2.903 1.18-2.903 2.636V4.98c0-1.456-1.3-2.636-2.903-2.636-1.604 0-2.904 1.18-2.904 2.636v18.226l-2.141-1.944c-.894-.812-2.082-1.259-3.346-1.259-1.264 0-2.452.447-3.346 1.259a1.12 1.12 0 00-.378.828c0 .31.136.609.378.829l8.286 7.524c1.452 1.318 2.268 3.106 2.268 4.971v3.41c0 .648.577 1.172 1.29 1.172h15.484c.713 0 1.29-.525 1.29-1.172V33.1C38.7 31.85 40 29.714 40 27.363V8.104c0-1.456-1.3-2.637-2.904-2.637zM4.731 8.984h-3.44C.577 8.984 0 8.46 0 7.812c0-.647.578-1.171 1.29-1.171h3.441c.713 0 1.29.524 1.29 1.171 0 .648-.577 1.172-1.29 1.172zM3.471 14.844c-.445 0-.88-.21-1.118-.586-.357-.56-.145-1.277.472-1.6l2.98-1.563c.617-.324 1.406-.132 1.763.429.356.56.145 1.277-.473 1.6l-2.98 1.563a1.385 1.385 0 01-.644.157zM6.449 4.688c-.219 0-.44-.051-.644-.158l-2.98-1.562c-.617-.324-.829-1.04-.472-1.6.356-.561 1.145-.753 1.762-.43l2.98 1.563c.618.323.83 1.04.473 1.6-.24.377-.673.587-1.119.587z"}})])
          )
        }
      }
    